import { render } from "./ProviderAnalysisCharts.vue?vue&type=template&id=50f68a2c&ts=true"
import script from "./ProviderAnalysisCharts.vue?vue&type=script&lang=ts"
export * from "./ProviderAnalysisCharts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__